export default __webpack_public_path__ + "static/media/banner-porto.c9199652.png";